import React from 'react';

import { ISanitizer, sanitize } from '~commonInfra/utils/Sanitize';

import { useSafeExternalLinks } from '../../../../leaving/UseSafeExternalLinks';
import { TextileHelper } from '../../../utils/TextileHelper';
import { DetailsTooltipStyles } from '../../card/DetailsTooltipStyles';
import { ContentDescriptionClassNames } from '../../tooltip/TooltipHelper';

export interface MarkupFieldProps {
  label?: string;
  markup: string;
  testId?: string;
  extraClasses?: string[];
  excludeImages?: boolean;
  disableMaxHeight?: boolean;
}

export function MarkupField(props: MarkupFieldProps) {
  const sanitizeFn = sanitize;
  const htmlContent = getSanitizedHtmlFromMarkup(props.markup, sanitizeFn);
  const renderedHtml = props.markup
    ? buildRenderedMarkupHtml(
      htmlContent.__html,
      props.excludeImages
    )
    : '';
  const { ref } = useSafeExternalLinks(renderedHtml);

  if (!renderedHtml) {
    return null;
  }

  const classes = [DetailsTooltipStyles.MetadataSection].concat(props.extraClasses).join(' ');

  return (
    <div className={classes}
      data-tb-test-id={props.testId}>

      {props.label && <div className={DetailsTooltipStyles.MultiLineTitle}>{props.label}</div>}

      <div ref={ ref }
        className={ContentDescriptionClassNames}
        style={{ maxHeight: props.disableMaxHeight ? 'none' : 'inherit' }}
        dangerouslySetInnerHTML={{ __html: renderedHtml }} />
    </div>
  );
}

/** Sanitized HTML plus default link targets and optional image stripping — same string as `dangerouslySetInnerHTML`. */
function buildRenderedMarkupHtml(sanitizedInnerHtml: string, excludeImages?: boolean): string {
  const $tempElement = $('<div></div>').html(sanitizedInnerHtml);
  // Open anchor tag links in a new tab by default
  $tempElement.find('a').not('[target]').attr('target', '_blank');
  if (excludeImages) {
    $tempElement.find('img').remove();
  }
  return $tempElement.html();
}

function getSanitizedHtmlFromMarkup(
  markup: string,
  sanitizeFn: ISanitizer
): { __html: string } {
  return { __html: TextileHelper.getSanitizedHtmlFromTextile(markup, sanitizeFn) };
}
